export enum BreakpointValue {
    SMALL = 0,
    MEDIUM = 1,
    LARGE = 2,
    XLARGE = 3
}
